import { getNumberFormatted } from '@/helpers/common';
import { COVER_PROPERTY_SPECIFIC_ITEMS } from '@/constants/products/home';

import {
  DATE_FORMAT,
} from '@/helpers/date';

import * as homeConstants from '@/constants/products/home';
import * as commonConstants from '@/constants/common';

const constants = Object.assign(
  {},
  commonConstants,
  homeConstants,
);

// regex
export const descriptionRegex = /^[A-Za-z0-9\-\s]+$/;

// templates
export const dateTemplate = {
  day: null,
  month: null,
  year: null,
};

// options helpers
export const reverseOrder = list => list.sort((a, b) => b.value - a.value);

export const isNull = val => val === null;

export const calcContentsSum = step => {
  const {
    propertyLaptopInsurance = false,
    bicyclesOrLaptopsDetails = [],
    propertyItemsInsurance = false,
    specificItemsDetails = [],
    allRisksUnspecified = null,
  } = step;

  let sum = 0;

  if (propertyLaptopInsurance &&
    bicyclesOrLaptopsDetails.length) {
    sum += bicyclesOrLaptopsDetails.reduce((a, b) => {
      return a + +b.propertyBicycleLaptopValue;
    }, 0);
  }

  if (propertyItemsInsurance &&
    specificItemsDetails.length) {
    sum += specificItemsDetails.reduce((a, b) => {
      return a + +b.propertySpecificItemsValue;
    }, 0);
  }

  if (allRisksUnspecified) {
    sum += +allRisksUnspecified;
  }

  return sum;
};

/**
* Return a list of options with animation image and description
* @param {Object} optionsObj - {@link HOME_PROPERTY_MAINDOR_LOCK} like object
* @param {Object} config - {@link DEFAULT_WL_CONFIG} like object
* @param {Object} lockAnimations - {@link LOCK_ANIMATIONS}
* @param {boolean} withOtherIcon - leave other lock type image
*/
export const createLocksOptions = (optionsObj, config, lockAnimations, withOtherIcon) => {
  return Object.keys(optionsObj).map(key => {
    const option = {
      value: key,
      ...optionsObj[key],
    };

    if (!withOtherIcon) {
      lockAnimations = omitObj(lockAnimations, 'O');
    }

    if (lockAnimations[key]) {
      // TODO check variable in BE response config
      const color = config?.lockAnimationColor || 'black';
      Object.assign(option, lockAnimations[key][color]);
    }

    return option;
  });
};

export const omitObj = (obj, key) => {
  const { [key]: omitted, ...rest } = obj;
  return rest;
};

// project structure
export const homeSteps = [
  {
    id: 'home',
    payloadKey: 'home',
    label: 'Your Home',
  },
  {
    id: 'content',
    payloadKey: 'content',
    label: 'Contents, Occupancy & Security',
  },
  {
    id: 'insured',
    payloadKey: 'insured',
    label: 'Your Details & Cover',
  },
];

// might be used for boomin - check on refactor
export const homeStructure = [
  {
    stepId: 'home',
    stepLabel: 'Your Home',
    groups: [
      {
        groupId: 'address',
        groupLabel: 'Your address',
        sections: [
          {
            sectionId: 'address',
            sectionLabel: 'What is your postcode?',
            fields: [
              'postcode',
              'address',
              'houseNumberOrName',
              'addressLine2',
              'addressLine3',
              'addressLine4',
            ],
          },
        ],
      },
      {
        groupId: 'home-policy',
        groupLabel: 'About Your Home & Your Policy',
        sections: [
          {
            sectionId: 'property-owned',
            sectionLabel: 'Do you own or rent your home?',
            fields: [
              'propertyOwned',
            ],
          },
          {
            sectionId: 'property-cover-type',
            sectionLabel: 'What would you like the insurance to cover?',
            fields: [
              'propertyCoverType',
            ],
          },
          {
            sectionId: 'property-sort',
            sectionLabel: 'What sort of property is it?',
            fields: [
              'propertySort',
            ],
          },
          {
            sectionId: 'property-type',
            sectionLabel: 'What type of property is it?',
            fields: [
              'propertyType',
            ],
          },
          {
            sectionId: 'property-floor',
            sectionLabel: 'Floor number?',
            fields: [
              'propertyFloor',
            ],
          },
          {
            sectionId: 'property-rooms',
            sectionLabel: 'How many rooms does the property have?',
            fields: [
              'propertyBedrooms',
              'propertyBathrooms',
              'propertyLivingrooms',
              'propertyOtherooms',
              'totalRooms',
            ],
          },
          {
            sectionId: 'property-year',
            sectionLabel: 'Approximately what year was your property built?',
            fields: [
              'propertyYear',
            ],
          },
          {
            sectionId: 'property-roof-made',
            sectionLabel: 'What is the roof made of?',
            fields: [
              'propertyRoofMade',
            ],
          },
          {
            sectionId: 'property-roof-flat',
            sectionLabel: 'Is any part of the roof flat?',
            fields: [
              'propertyFlatRoof',
            ],
          },
        ],
      },
      {
        groupId: 'assumptions',
        groupLabel: 'Assumptions About Your Property',
        sections: [
          {
            sectionId: 'property-walls-made',
            sectionLabel: 'What are the exterior walls made of?',
            fields: [
              'propertyWallsMade',
            ],
          },
          {
            sectionId: 'property-landslip-heave',
            sectionLabel: 'Is there a history/signs of heave, landslip or subsidence in the property OR in the area where the property is located?',
            fields: [
              'propertyLandslipHeave',
            ],
          },
          {
            sectionId: 'property-underpinning',
            sectionLabel: 'Has the property ever had underpinning or structural support?',
            fields: [
              'propertyUnderpinning',
            ],
          },
          {
            sectionId: 'property-flooding',
            sectionLabel: 'Has the property got a history of flooding or is it located in an area which has suffered from flooding?',
            fields: [
              'propertyUnderpinning',
            ],
          },
          {
            sectionId: 'property-work',
            sectionLabel: 'Is there any building work in progress?',
            fields: [
              'propertyWork',
            ],
          },
          {
            sectionId: 'property-nearest-river',
            sectionLabel: 'Is there any building work in progress?',
            fields: [
              'propertyNearestRiver',
            ],
          },
          {
            sectionId: 'property-listed',
            sectionLabel: 'Is your property a listed building?',
            fields: [
              'propertyListed',
            ],
          },
          {
            sectionId: 'property-main-residence',
            sectionLabel: 'Is this property the proposer\'s main residence?',
            fields: [
              'propertyMainResidence',
            ],
          },
          {
            sectionId: 'property-state-of-repair',
            sectionLabel: 'Is the property in good state of repair?',
            fields: [
              'propertyStateOfRepair',
            ],
          },
          {
            sectionId: 'property-nearest-tree',
            sectionLabel: 'Are there trees taller than 10 metres within 5 metres of your building?',
            fields: [
              'propertyNearestTree',
            ],
          },
          {
            sectionId: 'property-assumptions-confirm',
            sectionLabel: 'Are the statements above correct?',
            fields: [
              'isAssumptionsCorrect',
            ],
          },
        ],
      },
      {
        groupId: 'buildings-cover',
        groupLabel: 'Buildings Cover',
        sections: [
          {
            sectionId: 'build-sums-ins',
            sectionLabel: 'What would the cost be to rebuild the property?',
            fields: [
              'buildSumsIns',
            ],
          },
        ],
      },
    ],
  },
  {
    stepId: 'content',
    stepLabel: 'Contents, Occupancy & Security',
    groups: [
      {
        groupId: 'contents',
        groupLabel: 'Contents Cover',
        sections: [
          {
            sectionId: 'property-laptop-insurance',
            sectionLabel: 'Do you want to insure any bicycles or laptops?',
            fields: [
              'propertyLaptopInsurance',
              'bicyclelaptops',
              {
                parent: 'bicyclelaptop',
                fields: [
                  'propertyBicycleOrLaptop',
                  'propertyBicycleLaptopDescription',
                  'propertyBicycleLaptopValue',
                  'propertyBicycleLaptopOutside',
                ],
              },
              'formOpenBicycleLaptop',
            ],
          },
          {
            sectionId: 'property-items-insurance',
            sectionLabel: 'Do you want to insure specific items worth over £1000 each?',
            fields: [
              'propertyItemsInsurance',
              'specificitem',
              {
                parent: 'specificitem',
                fields: [
                  'propertySpecificItemsItem',
                  'propertySpecificItemsDescription',
                  'propertySpecificItemsValue',
                  'propertySpecificItemsOutside',
                ],
              },
              'formOpenSpecificItem',
            ],
          },
          {
            sectionId: 'all-risks-unspecified',
            sectionLabel: 'Would you like to insure any personal possessions you take away from your home? (Items under £1000)',
            fields: [
              'allRisksUnspecified',
            ],
          },
          {
            sectionId: 'contents-sums-ins',
            sectionLabel: 'How much would it cost to replace the entire contents in your home?',
            fields: [
              'contentsSumsIns',
            ],
          },
        ],
      },
      {
        groupId: 'occupancy',
        groupLabel: 'Occupancy',
        sections: [
          {
            sectionId: 'property-purchased',
            sectionLabel: 'When was the property purchased?',
            fields: ['propertyPurchased'],
          },
          {
            sectionId: 'property-years-lived',
            sectionLabel: 'How many years have you lived here?',
            fields: ['propertyYearsLived'],
          },
          {
            sectionId: 'property-occupied',
            sectionLabel: 'Who is the property occupied by?',
            fields: ['propertyOccupied'],
          },
          {
            sectionId: 'property-occupied-by',
            sectionLabel: 'Who is the property occupied by?',
            fields: [
              'propertyAdults',
              'propertyChildren',
              'occupiedBy',
            ],
          },
          {
            sectionId: 'property-smoker',
            sectionLabel: 'Does anybody living in the property smoke?',
            fields: ['propertySmoker'],
          },
          {
            sectionId: 'property-unoccupied',
            sectionLabel: 'When is your property normally unoccupied?',
            fields: ['propertyUnoccupied'],
          },
          {
            sectionId: 'property-unoccupied-days',
            sectionLabel: 'For how many days in a row is the property left empty?',
            fields: ['propertyUnoccupiedDays'],
          },
          {
            sectionId: 'property-business-type',
            sectionLabel: 'Is the property used for your business purposes?',
            fields: ['propertyBusinessType'],
          },
        ],
      },
      {
        groupId: 'security',
        groupLabel: 'Security',
        sections: [
          {
            sectionId: 'property-alarm-installed',
            sectionLabel: 'Does the property have an alarm system installed?',
            fields: ['propertyAlarmInstalled'],
          },
          {
            sectionId: 'property-prof-alarm',
            sectionLabel: 'Has the alarm been fitted and maintained annually by a NACOSS, NSI or SSAIB approved company?',
            fields: ['propertyProfAlarm'],
          },
          {
            sectionId: 'property-alert-alarm',
            sectionLabel: 'Is the alarm monitored?',
            fields: ['propertyAlertAlarm'],
          },
          {
            sectionId: 'property-maindor-lock',
            sectionLabel: 'What kind of lock is fitted to your main external door?',
            fields: ['propertyMaindorLock'],
          },
          {
            sectionId: 'property-patiodor-lock',
            sectionLabel: 'Do you have any patio doors?',
            fields: ['propertyPatiodorLock'],
          },
          {
            sectionId: 'property-externaldor-lock',
            sectionLabel: 'Do you have any other external doors?',
            fields: ['propertyExternaldorLock'],
          },
          {
            sectionId: 'property-window-lock',
            sectionLabel: 'Do all accessible windows (ground floor) have key operated locks?',
            fields: ['propertyWindowLock'],
          },
          {
            sectionId: 'property-total-smoke-alarms',
            sectionLabel: 'How many working smoke alarms are there?',
            fields: ['propertyTotalSmokeAlarms'],
          },
          {
            sectionId: 'property-local-watch',
            sectionLabel: 'Is there a local Neighbourhood Watch?',
            fields: ['propertyLocalWatch'],
          },
        ],
      },
    ],
  },
  {
    stepId: 'insured',
    stepLabel: 'Your Details & Cover',
    groups: [
      {
        groupId: 'insured-details',
        groupLabel: 'Your Details',
        sections: [
          {
            sectionId: 'title',
            sectionLabel: 'What is your title?',
            fields: ['title'],
          },
          {
            sectionId: 'name',
            sectionLabel: 'What is your name?',
            fields: [
              'firstName',
              'surname',
            ],
          },
          {
            sectionId: 'date-of-birth',
            sectionLabel: 'What is your date of birth?',
            fields: ['dateOfBirth'],
          },
          {
            sectionId: 'address-contact',
            sectionLabel: 'Is your postal address the same as the one being insured?',
            fields: [
              'isPostalAddressSameAsInsured',
              'postcode',
              'address',
              'houseNumberOrName',
            ],
          },
          {
            sectionId: 'marital-status',
            sectionLabel: 'What is your relationship status?',
            fields: [
              'maritalStatus',
            ],
          },
          {
            sectionId: 'employment-status',
            sectionLabel: 'What is your employment status?',
            fields: ['employmentStatus'],
          },
          {
            sectionId: 'occupation',
            sectionLabel: 'What is your occupation?',
            fields: [
              'occupationList',
              'occupationKey',
            ],
          },
          {
            sectionId: 'business',
            sectionLabel: 'What is your business type?',
            fields: [
              'businessKey',
              'businessList',
            ],
          },
          {
            sectionId: 'another-job',
            sectionLabel: 'Do you have a part-time occupation?',
            fields: [
              'partTimeOccupation',
              'businessKeyPt',
              'businessListPt',
              'occupationListPt',
              'occupationKeyPt',
            ],
          },
          {
            sectionId: 'telephone',
            sectionLabel: 'What is your phone number?',
            fields: ['telephone'],
          },
          {
            sectionId: 'email',
            sectionLabel: 'What is your email address?',
            fields: ['email'],
          },
        ],
      },
      {
        groupId: 'joint-insured',
        groupLabel: 'Joint Proposer Details',
        sections: [
          {
            sectionId: 'joint-insured',
            sectionLabel: 'Do you wish to have another person named on your insurance policy?',
            fields: [
              'jointInsured',
              'additional-insured',
              'additional-insured-relationship-to-proposer',
              {
                parent: 'additional-insured',
                fields: [
                  'additionalTitle',
                  'additionalFirstName',
                  'additionalSurname',
                  'additionalDateOfBirth',
                  'additionalMaritalStatus',
                  'additionalRelationshipProposer',
                  'additionalEmploymentStatus',
                  'additionalOccupationKey',
                  'additionalOccupationList',
                  'additionalBusinessKey',
                  'additionalBusinessList',
                  'additionalPartTimeOccupation',
                  'additionalOccupationKeyPt',
                  'additionalOccupationListPt',
                  'additionalBusinessKeyPt',
                  'additionalBusinessListPt',
                ],
              },
              'formOpen',
            ],
          },
        ],
      },
      {
        groupId: 'policy-history',
        groupLabel: 'Your Policy History',
        sections: [
          {
            sectionId: 'property-bankrupt',
            sectionLabel: 'Have you, any proposed joint party, or anyone living at the property ever been bankrupt?',
            fields: ['propertyBankrupt'],
          },
          {
            sectionId: 'special-terms-policy',
            sectionLabel: 'Have you or any occupant ever had any special terms imposed on previous insurance policies?',
            fields: ['specialTermsPolicy'],
          },
          {
            sectionId: 'policy-declined',
            sectionLabel: 'Have you or any other occupant ever had insurance declined, cancelled or voided?',
            fields: ['policyDeclined'],
          },
          {
            sectionId: 'occupants-convictions',
            sectionLabel: 'Do any occupants have any unspent criminal convictions or pending prosecutions?',
            fields: ['occupantsConvictions'],
          },
          {
            sectionId: 'claims',
            sectionLabel: 'Have you or anyone living at the property had any insurance claims in the last 5 years?',
            fields: [
              'propertyInsuranceClaims',
              'claims',
              {
                parent: 'claim',
                fields: [
                  'claimDate',
                  'propertyClaimType',
                  'claimCause',
                  'claimStatus',
                  'claimAmount',
                  'claimLocation',
                ],
              },
              'formOpenClaims',
            ],
          },
        ],
      },
      {
        groupId: 'cover',
        groupLabel: 'Final questions for your cover',
        sections: [
          {
            sectionId: 'date-of-insurance-start',
            sectionLabel: 'When should the insurance policy begin?',
            fields: ['dateOfInsuranceStart'],
          },
          {
            sectionId: 'property-payment-type',
            sectionLabel: 'How would you like to pay for the insurance policy?',
            fields: ['propertyPaymentType'],
          },
          {
            sectionId: 'build-no-claims-bonus',
            sectionLabel: 'How many years no claim discount do you have for building insurance?',
            fields: ['buildNoClaimsBonus'],
          },
          {
            sectionId: 'contents-no-claims-bonus',
            sectionLabel: 'How many years no claim discount do you have for contents insurance?',
            fields: ['contentsNoClaimsBonus'],
          },
          {
            sectionId: 'build-voluntary-excess',
            sectionLabel: 'How much voluntary excess would you like for your buildings cover?',
            fields: ['buildVoluntaryExcess'],
          },
          {
            sectionId: 'contents-voluntary-excess',
            sectionLabel: 'How much voluntary excess would you like for your contents cover?',
            fields: ['contentsVoluntaryExcess'],
          },
          {
            sectionId: 'build-acc-dam',
            sectionLabel: 'Do you wish to cover your building against accidental damage?',
            fields: ['buildAccDam'],
          },
          {
            sectionId: 'contents-acc-dam',
            sectionLabel: 'Do you require accidental damage cover for your contents?',
            fields: ['contentsAccDam'],
          },
        ],
      },
      {
        groupId: 'final-details',
        groupLabel: 'Final Details',
        sections: [
          {
            sectionId: 'user-data',
            sectionLabel: 'Account details',
            fields: ['userData', 'userDataConfirm', 'userLoginEmail', 'userLoginPassword', 'userLoginOneTimePassword'],
          },
          {
            sectionId: 'outbound',
            sectionLabel: 'Finding the right cover',
            fields: ['outbound'],
          },
          {
            sectionId: 'direct-marketing-options',
            sectionLabel: 'Marketing options',
            fields: [
              'directMarketingEmail',
              'directMarketingSms',
              'directMarketingPost',
              'directMarketingPhone',
            ],
          },
          {
            sectionId: 'user-keep-sign-in',
            sectionLabel: 'Keep me signed in',
            fields: ['userKeepSignIn'],
          },
        ],
      },
    ],
  },
];

export const getFormattedSubformPreviewList = (item) => {
  const {
    propertySpecificItemsValue,
    propertySpecificItemsDescription,
    propertySpecificItemsOutside,
    propertyBicycleLaptopValue,
    propertyBicycleLaptopDescription,
    propertyBicycleLaptopOutside,
  } = item;

  if (item.propertyBicycleOrLaptop) {
    return [
      { prepend: item.propertyBicycleOrLaptop === 'B' ? 'Bicycle' : 'Laptop' },
      { prepend: `£${getNumberFormatted(propertyBicycleLaptopValue)}` },
      { prepend: propertyBicycleLaptopDescription },
      {
        prepend: 'Cover away from home:',
        value: propertyBicycleLaptopOutside ? 'Yes' : 'No',
      },
    ];
  }

  return [
    { prepend: COVER_PROPERTY_SPECIFIC_ITEMS[item.propertySpecificItemsItem] },
    { prepend: `£${getNumberFormatted(propertySpecificItemsValue)}` },
    { prepend: propertySpecificItemsDescription },
    {
      prepend: 'Cover away from home:',
      value: propertySpecificItemsOutside ? 'Yes' : 'No',
    },
  ];
};

export const getClaimsRules = claim => ({
  claimDate: {
    date_format: DATE_FORMAT,
    before: {
      compare: 'today',
      equal: true,
    },
    after: {
      compare: '-5 years',
    },
  },

  propertyClaimType: {
    required: true,
    in: {
      items: constants.CLAIM_PROPERTY_CLAIM_TYPE,
    },
  },

  claimCause: {
    required: true,
    in: {
      items: constants.CLAIM_CAUSE,
    },
  },

  claimStatus: {
    required: true,
    in: {
      items: constants.CLAIM_STATUS,
    },
  },

  claimAmount: (() => {
    if (claim.claimStatus === 'NC') return {};

    return {
      is_not: { other: null },
      integer: true,
      claimAmount: true,
    };
  })(),

  claimLocation: {
    required: true,
    typeof: 'boolean',
  },
});
